import "./Cart.scss";

import { useEffect, useState } from "react";
import Product from "./components/Product";
import { useNavigate } from "react-router-dom";
import { sendOrder } from "../../services/orders";
import { guestLogin } from "../../services/auth";
import { useCookies } from "react-cookie";
import { checkPromocode } from "../../services/promocodes";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { getAddresses, getNeighbourhoods } from "../../services/userService";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { getCategory } from "../../services/products";
import { isWithinOrderingWindow } from "../../utils/orderingWindow";

const MIN_OERDER_AMOUNT = 15.34; // 30 BGN in EUR

const newIdempotencyKey = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

export default function Cart({
  setOpenLogin,
  cart,
  setCart,
  user,
  setOpenConfirmation,
  setOpenBurger,
  showMessage,
  setShowMessage,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [orderSteps, setOrderSteps] = useState(1);
  const [isEmpty, setIsEmpty] = useState(false);

  const [finalPrice, setFinalPrice] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(6.0);
  const [priceBeforePromo, setPriceBeforePromo] = useState(null);
  const [usedPromocode, setUsedPromocode] = useState("");
  const [validPromo, setValidPromo] = useState();
  const [promoAlreadyApplied, setPromoAlreadyApplied] = useState(false);
  const [promoError, setPromoError] = useState("");
  const [discount, setDiscount] = useState(0);

  const [wrongAddress, setWrongAddress] = useState(false);
  const [nonDuplicateCart, setNonDuplicateCart] = useState([]);

  const [deliverOrTake, setDeliveryOrTake] = useState(2);
  const [date, setDate] = useState();
  const [hours, setHours] = useState();
  const [minutes, setMinutes] = useState();
  const [fullDate, setFullDate] = useState("");

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [street, setStreet] = useState("");
  const [deliveryOption, setDeliveryOption] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState(1);
  const [message, setMessage] = useState("");
  const [policyConfirm, setPolicyConfirm] = useState(false);
  const [termsConfirm, setTermsConfirm] = useState(false);

  const [policyError, setPolicyError] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [streetError, setStreetError] = useState(false);
  const [deliveryError, setDeliveryError] = useState(false);
  const [paymentError, setPaymentError] = useState(false);
  const [neighbourhoodError, setNeighbourhoodError] = useState(false);
  const [stepError, setStepError] = useState(false);

  const [orderResponse, setOrderResponse] = useState();
  const [confirmShow, setConfirmShow] = useState(false);
  const [orderError, setOrderError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Reused for every press of "send" for the same checkout, so the backend
  // never places the same order twice.
  const idempotencyKeyRef = useRef(null);

  const [openAddressDropdown, setOpenAddressDropdown] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const addressRef = useRef(null);
  const [isNewAddress, setIsNewAddress] = useState(false);

  const [openNeighbourhoodDropdown, setOpenNeighbourhoodDropdown] =
    useState(false);
  const [neighbourhoods, setNeighbourhoods] = useState([]);
  const neighbourhoodsRef = useRef(null);
  const [selectedNeighbourhood, setSelectedNeighbourhood] = useState("");
  const [fullAddress, setFullAddress] = useState("");

  const [finalPriceBGN, setFinalPriceBGN] = useState(null);
  const [deliveryFeeBGN, setDeliveryFeeBGN] = useState(null);
  const [finalWithDeliveryBGN, setFinalWithDeliveryBGN] = useState(null);
  const [discountBGN, setDiscountBGN] = useState(null);

  useEffect(() => {
    if (!finalPrice) return;

    setFinalPriceBGN((Number(finalPrice) * 1.95583)?.toFixed(2));
  }, [finalPrice]);

  useEffect(() => {
    if (!deliveryFee) return;

    setDeliveryFeeBGN((Number(deliveryFee) * 1.95583)?.toFixed(2));
  }, [deliveryFee]);

  useEffect(() => {
    if (!finalPrice || !deliveryFee) return;

    setFinalWithDeliveryBGN(
      ((Number(finalPrice) + Number(deliveryFee)) * 1.95583)?.toFixed(2),
    );
  }, [finalPrice, deliveryFee]);

  useEffect(() => {
    if (!discount) return;

    setDiscountBGN((Number(discount) * 1.95583)?.toFixed(2));
  }, [discount]);

  useEffect(() => {
    getAddresses(cookie.access_token).then((res) => {
      res !== "Unauthorized" ? setAddresses(res) : setAddresses([]);
    });
    getNeighbourhoods(cookie.access_token).then((res) => {
      setNeighbourhoods(res.data);
    });
  }, []);

  useEffect(() => {
    if (deliverOrTake === 1) {
      setDeliveryFee(0);
    } else if (deliverOrTake === 2) {
      setDeliveryFee(Number(6 / 1.95583).toFixed(2));
    }
  }, [deliverOrTake]);

  useEffect(() => {
    if (date && hours && minutes) {
      const [year, month, day] = date.split("-").map(Number);
      const validDate = new Date(year, month - 1, day, hours, minutes);
      setFullDate(validDate);
    }
  }, [date, hours, minutes]);

  useEffect(() => {
    function combineAmounts(arr) {
      const combined = {};

      // Iterate over the array and combine amounts
      arr.forEach((item) => {
        const {
          id,
          amount,
          allergens,
          description,
          images,
          name,
          nutritionValues,
          price,
          added,
          removed,
          singlePrice,
          isCombo,
          chosenWeight,
          category,
        } = item;

        // The chosen weight is part of the identity: two grammages of the same
        // meal have different prices and must stay separate lines.
        const key = `${id}_${JSON.stringify(added)}_${JSON.stringify(
          removed,
        )}_${chosenWeight ?? ""}`;

        if (combined[key]) {
          combined[key].amount += amount;
        } else {
          combined[key] = {
            id,
            amount,
            allergens,
            description,
            images,
            name,
            nutritionValues,
            price,
            added,
            removed,
            singlePrice,
            isCombo,
            chosenWeight,
            category,
          };
        }
      });

      // Convert combined object back to array
      const result = Object.values(combined);

      return result;
    }

    setNonDuplicateCart(combineAmounts(cart));
  }, [, cart]);

  const deviceType = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    ? "mobile"
    : "desktop";

  useEffect(() => {
    setOpenBurger(false);
    if (cart?.length > 0) {
      setIsEmpty(false);
    } else {
      setIsEmpty(true);
    }
  }, []);

  useEffect(() => {
    user?.email !== null && setEmail(user?.email);
    user?.phone !== null && setPhone(user?.phone);
  }, [user]);

  useEffect(() => {
    selectedNeighbourhood !== "" &&
      setFullAddress(`гр. София, ${selectedNeighbourhood || ""}`);
  }, [selectedNeighbourhood]);

  useEffect(() => {
    // Update final price when cart changes
    let totalPrice = cart?.reduce(
      (acc, curr) => acc + Number(curr?.amount) * Number(curr?.price),
      0,
    );
    setFinalPrice(totalPrice);
    setPriceBeforePromo(totalPrice);

    if (cart?.length > 0) {
      setIsEmpty(false);
    } else {
      setIsEmpty(true);
    }
  }, [cart]);

  const [disabledCategories, setDisabledCategories] = useState([]);

  useEffect(() => {
    const checkCategories = async () => {
      let categorySet = new Set(); // Use a Set to avoid duplicates.

      await Promise.all(
        nonDuplicateCart?.map(async (product) => {
          const res = await getCategory(
            product?.category?.id,
            cookie?.access_token,
          );
          if (res?.isActive === false) {
            categorySet.add(res.name); // Add the name to the set if the category is disabled.
          }
        }),
      );

      setDisabledCategories([...categorySet]); // Convert Set back to Array and update the state.
    };

    checkCategories();
  }, [nonDuplicateCart]);

  const handlePromocode = () => {
    if (promoAlreadyApplied) {
      setPromoAlreadyApplied(false);
      setDiscount(0);
      setFinalPrice(priceBeforePromo);
    }
    if (usedPromocode !== "") {
      checkPromocode(usedPromocode, cookie.access_token).then((res) => {
        if (res !== "PROMO_CODE_NOT_FOUND_ERROR") {
          setValidPromo(res);
        } else {
          setPromoError("Промо кодът не беше намерен.");
        }
      });
    }
  };

  useEffect(() => {
    if (!promoAlreadyApplied) {
      if (validPromo && validPromo?.percent !== null && validPromo.isValid) {
        setDiscount(
          (Number(finalPrice) * (validPromo?.percent / 100))?.toFixed(2),
        );
        setFinalPrice(Number(finalPrice) * (1 - validPromo?.percent / 100));
        setPromoAlreadyApplied(true);
        setPromoError("");
      }
      if (
        validPromo &&
        validPromo?.amount !== null &&
        finalPrice - validPromo?.amount > 0 &&
        validPromo.isValid
      ) {
        setDiscount(Number(validPromo?.amount)?.toFixed(2));
        setFinalPrice(Number(finalPrice) - Number(validPromo?.amount));
        setPromoAlreadyApplied(true);
        setPromoError("");
      }

      if (
        validPromo &&
        ((validPromo?.percent === null && validPromo?.amount === null) ||
          finalPrice - validPromo?.amount < 0 ||
          !validPromo.isValid)
      ) {
        setPromoError(
          "Промо кодът е невалиден или неприложим за избраните продукти",
        );
      }
    }
  }, [validPromo]);

  const renderHours = () => {
    let hours = [];
    for (let i = 11; i <= 20; i++) {
      hours.push(
        <option value={i} key={i}>
          {i}
        </option>,
      );
    }
    return hours;
  };

  const renderMinutes = () => {
    let minutes = [];
    let i = 15;
    while (i < 60) {
      minutes.push(
        <option value={i} key={i}>
          {i}
        </option>,
      );
      i = i + 15;
    }
    return minutes;
  };

  const handleDeliveryStep = () => {
    const isDelivery = deliverOrTake === 2;
    const isTakeout = deliverOrTake === 1;

    setEmailError(!email);
    setPhoneError(!phone);
    setDeliveryError(!deliveryOption);
    setNeighbourhoodError(isDelivery && !selectedNeighbourhood);
    setStreetError(isDelivery && !street);
    setPaymentError(isTakeout && !paymentMethod);

    const isValid =
      email &&
      phone &&
      deliveryOption &&
      (!isDelivery || (selectedNeighbourhood && street)) &&
      (!isTakeout || paymentMethod);

    if (!isValid) {
      setStepError(true);
      setTimeout(() => {
        document
          .querySelector(".order-wrapper .error")
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
      });
      return;
    }

    setStepError(false);
    setOrderSteps(3);
  };

  const handleOrder = () => {
    setOrderError("");
    !policyConfirm && setPolicyError(true);
    !termsConfirm && setTermsError(true);
    !email ? setEmailError(true) : setEmailError(false);
    !phone ? setPhoneError(true) : setPhoneError(false);
    !deliveryOption ? setDeliveryError(true) : setDeliveryError(false);
    !paymentMethod ? setPaymentError(true) : setPaymentError(false);
    !street ? setStreetError(true) : setStreetError(false);
    !selectedNeighbourhood
      ? setNeighbourhoodError(true)
      : setNeighbourhoodError(false);

    const checkDelivery = deliverOrTake === 2 ? fullAddress && street : true;
    const checkTime = deliveryOption === 2 ? date && hours && minutes : true;

    if (
      policyConfirm &&
      termsConfirm &&
      email &&
      phone &&
      deliveryOption &&
      checkTime &&
      paymentMethod &&
      checkDelivery
    ) {
      if (!isWithinOrderingWindow()) {
        const outsideWorkingHoursMessage = t(
          "orders-limit.errors.outsideWorkingHours",
        );

        setOrderError(outsideWorkingHoursMessage);
        setShowMessage(outsideWorkingHoursMessage);
        return;
      }

      if (isSubmitting) return;
      if (!idempotencyKeyRef.current) {
        idempotencyKeyRef.current = newIdempotencyKey();
      }
      setIsSubmitting(true);

      sendOrder(
        email,
        phone,
        deliverOrTake === 2 ? `${fullAddress}, ${street}` : "takeout",
        nonDuplicateCart,
        paymentMethod,
        deliveryOption === 1 ? "ASAP" : fullDate,
        usedPromocode,
        message,
        cookie["access_token"],
        idempotencyKeyRef.current,
      )
        .then((res) => {
          if (res.status === 201) {
            idempotencyKeyRef.current = null;
            setOrderResponse(res.status);
            return;
          }

          const errorCode = res?.data?.message;
          let errorMessage;

          switch (errorCode) {
            case "ORDERS_OUTSIDE_WORKING_HOURS_ERROR":
              errorMessage = t("orders-limit.errors.outsideWorkingHours");
              break;
            case "BARSY_ORDER_ERROR":
              errorMessage = t("orders-limit.errors.notSent");
              break;
            case "ORDER_IN_PROGRESS_ERROR":
              errorMessage = t("orders-limit.errors.inProgress");
              break;
            default:
              errorMessage = t("orders-limit.errors.generic", {
                requestId: res?.headers?.["x-request-id"] || "-",
              });
          }

          setOrderError(errorMessage);
          setShowMessage(errorMessage);
        })
        .catch(() => {
          const errorMessage = t("orders-limit.errors.generic", {
            requestId: "-",
          });
          setOrderError(errorMessage);
          setShowMessage(errorMessage);
        })
        .finally(() => setIsSubmitting(false));
    }
  };

  useEffect(() => {
    if (orderResponse === 201) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (typeof window.gtag === "function") {
        window.gtag("event", "purchase", {
          currency: "EUR",
          value: finalPrice, // Replace with the total purchase value
          shipping: deliveryFee, // Replace with shipping cost
          items: cart, // Replace with the purchased items
        });
      } else {
        console.error("gtag is not defined!");
      }
      setConfirmShow(true);
      setOpenConfirmation(true);
    }
  }, [orderResponse]);

  useEffect(() => {
    idempotencyKeyRef.current = null;
  }, [
    nonDuplicateCart,
    email,
    phone,
    deliverOrTake,
    fullAddress,
    street,
    deliveryOption,
    fullDate,
    paymentMethod,
    usedPromocode,
    message,
  ]);

  useEffect(() => {
    policyConfirm && setPolicyError(false);
    termsConfirm && setTermsError(false);
  }, [policyConfirm, termsConfirm]);

  useEffect(() => {
    email && setEmailError(false);
  }, [email]);

  useEffect(() => {
    phone && setPhoneError(false);
  }, [phone]);

  useEffect(() => {
    street && setStreetError(false);
  }, [street]);

  useEffect(() => {
    selectedNeighbourhood && setNeighbourhoodError(false);
  }, [selectedNeighbourhood]);

  useEffect(() => {
    if (
      !emailError &&
      !phoneError &&
      !streetError &&
      !neighbourhoodError &&
      !deliveryError &&
      !paymentError
    ) {
      setStepError(false);
    }
  }, [
    emailError,
    phoneError,
    streetError,
    neighbourhoodError,
    deliveryError,
    paymentError,
  ]);

  useEffect(() => {
    deliveryOption && setDeliveryError(false);
  }, [deliveryOption]);

  useEffect(() => {
    paymentMethod && setPaymentError(false);
  }, [paymentMethod]);

  const [response, setResponse] = useState();
  const [cookie, setCookie] = useCookies(["access_token"]);

  const handleGuest = () => {
    guestLogin().then((res) => setResponse(res));
  };

  useEffect(() => {
    response?.data?.access_token &&
      setCookie("access_token", response?.data?.access_token, { path: "/" });
  }, [response]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (addressRef.current && !addressRef.current.contains(event.target)) {
        setOpenAddressDropdown(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [addressRef]);

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const checkTime = () => {
      if (deliverOrTake === 1) {
        setDeliveryFee(0);
      } else if (deliverOrTake === 2) {
        const baseDeliveryFee =
          finalPrice >= 100.0 ? "0.00" : Number(6 / 1.95583).toFixed(2);
        setDeliveryFee(baseDeliveryFee);
      }

      setIsDisabled(
        finalPrice < MIN_OERDER_AMOUNT || !isWithinOrderingWindow(),
      );
    };

    // Call checkTime immediately to set the initial state of the button
    checkTime();

    // Set an interval to check the time every minute
    const intervalId = setInterval(checkTime, 60000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [deliverOrTake, finalPrice]);

  return (
    <div className={!isEmpty ? "cart-wrapper" : "cart-wrapper empty"}>
      <div className="title-wrap">
        <div className="title">
          <p>
            {orderSteps === 1
              ? `${t("cart")}`
              : (orderSteps === 2 || orderSteps === 3) && `${t("quick-order")}`}
          </p>
        </div>
        {deviceType === "desktop" && (!user || user.isGuest) ? (
          <div
            className="log-in-button"
            onClick={() => {
              setOpenLogin(true);
            }}
          >
            <div className="icon">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.4336 0H7.13672C5.71875 0 4.57031 1.14844 4.57031 2.56641V6.26074H6.98437L6.80273 6.0791C6.3252 5.58984 6.33105 4.80762 6.82031 4.32715C7.30078 3.85547 8.07422 3.85547 8.55469 4.32715L10.8516 6.62402C11.335 7.10742 11.335 7.89258 10.8516 8.37598L8.55469 10.6729C8.07715 11.1621 7.29199 11.168 6.80273 10.6904C6.31348 10.2129 6.30762 9.42773 6.78516 8.93848L6.80273 8.9209L6.98437 8.73926H4.57031V12.4336C4.57031 13.8516 5.71875 15 7.13672 15H12.4336C13.8516 15 15 13.8516 15 12.4336V2.56641C15 1.14844 13.8516 0 12.4336 0Z"
                  fill="#343434"
                />
                <path
                  d="M7.13965 9.26074C6.84375 9.55664 6.84375 10.0371 7.13965 10.333C7.43555 10.6289 7.91602 10.6289 8.21191 10.333L10.5088 8.03613C10.8047 7.74023 10.8047 7.25977 10.5088 6.96387L8.21191 4.66699C7.91602 4.37109 7.43555 4.37109 7.13965 4.66699C6.84375 4.96289 6.84375 5.44336 7.13965 5.73926L8.14453 6.74121H0.720703C0.322266 6.74121 0 7.06348 0 7.46191V7.53516C0 7.93359 0.322266 8.25586 0.720703 8.25586H8.14453L7.13965 9.26074Z"
                  fill="#343434"
                />
              </svg>
            </div>
            <div className="text">Вход</div>
          </div>
        ) : (
          deviceType === "mobile" &&
          orderSteps === 1 &&
          !isEmpty && (
            <div
              className="empty-cart-button"
              onClick={() => {
                setCart([]);
                setIsEmpty(true);
              }}
            >
              <div className="text">
                <p>{t("clear-cart")}</p>
              </div>
              <div className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.833 5.83337C15.612 5.83337 15.4 5.92117 15.2438 6.07745C15.0875 6.23373 14.9997 6.44569 14.9997 6.66671V15.9925C14.9758 16.4139 14.7863 16.8088 14.4726 17.0912C14.1589 17.3736 13.7463 17.5205 13.3247 17.5H6.67467C6.25309 17.5205 5.84049 17.3736 5.52676 17.0912C5.21303 16.8088 5.02358 16.4139 4.99967 15.9925V6.66671C4.99967 6.44569 4.91188 6.23373 4.7556 6.07745C4.59932 5.92117 4.38735 5.83337 4.16634 5.83337C3.94533 5.83337 3.73337 5.92117 3.57709 6.07745C3.42081 6.23373 3.33301 6.44569 3.33301 6.66671V15.9925C3.35679 16.8561 3.72183 17.675 4.34816 18.2699C4.97449 18.8648 5.81107 19.1873 6.67467 19.1667H13.3247C14.1883 19.1873 15.0249 18.8648 15.6512 18.2699C16.2775 17.675 16.6426 16.8561 16.6663 15.9925V6.66671C16.6663 6.44569 16.5785 6.23373 16.4223 6.07745C16.266 5.92117 16.054 5.83337 15.833 5.83337Z"
                    fill="#FEAC7A"
                  />
                  <path
                    d="M16.6667 3.33337H13.3333V1.66671C13.3333 1.44569 13.2455 1.23373 13.0893 1.07745C12.933 0.921171 12.721 0.833374 12.5 0.833374H7.5C7.27899 0.833374 7.06702 0.921171 6.91074 1.07745C6.75446 1.23373 6.66667 1.44569 6.66667 1.66671V3.33337H3.33333C3.11232 3.33337 2.90036 3.42117 2.74408 3.57745C2.5878 3.73373 2.5 3.94569 2.5 4.16671C2.5 4.38772 2.5878 4.59968 2.74408 4.75596C2.90036 4.91224 3.11232 5.00004 3.33333 5.00004H16.6667C16.8877 5.00004 17.0996 4.91224 17.2559 4.75596C17.4122 4.59968 17.5 4.38772 17.5 4.16671C17.5 3.94569 17.4122 3.73373 17.2559 3.57745C17.0996 3.42117 16.8877 3.33337 16.6667 3.33337ZM8.33333 3.33337V2.50004H11.6667V3.33337H8.33333Z"
                    fill="#FEAC7A"
                  />
                  <path
                    d="M9.16667 14.1667V8.33333C9.16667 8.11232 9.07887 7.90036 8.92259 7.74408C8.76631 7.5878 8.55435 7.5 8.33333 7.5C8.11232 7.5 7.90036 7.5878 7.74408 7.74408C7.5878 7.90036 7.5 8.11232 7.5 8.33333V14.1667C7.5 14.3877 7.5878 14.5996 7.74408 14.7559C7.90036 14.9122 8.11232 15 8.33333 15C8.55435 15 8.76631 14.9122 8.92259 14.7559C9.07887 14.5996 9.16667 14.3877 9.16667 14.1667Z"
                    fill="#FEAC7A"
                  />
                  <path
                    d="M12.4997 14.1667V8.33333C12.4997 8.11232 12.4119 7.90036 12.2556 7.74408C12.0993 7.5878 11.8874 7.5 11.6663 7.5C11.4453 7.5 11.2334 7.5878 11.0771 7.74408C10.9208 7.90036 10.833 8.11232 10.833 8.33333V14.1667C10.833 14.3877 10.9208 14.5996 11.0771 14.7559C11.2334 14.9122 11.4453 15 11.6663 15C11.8874 15 12.0993 14.9122 12.2556 14.7559C12.4119 14.5996 12.4997 14.3877 12.4997 14.1667Z"
                    fill="#FEAC7A"
                  />
                </svg>
              </div>
            </div>
          )
        )}
      </div>

      {(deviceType === "desktop" ||
        (deviceType === "mobile" && orderSteps === 1) ||
        orderSteps === 2) && (
        <div className="info">
          <div className="boxes">
            <div className="delivery-info salmon">
              <div className="icon">
                <img
                  src="https://alexfish-static.s3.eu-north-1.amazonaws.com/info.svg"
                  alt="Info"
                />
              </div>
              <div className="text">{t("cart-message")}</div>
            </div>
          </div>
          {orderSteps === 1 && window.screen.width > 767 && !isEmpty && (
            <div
              className="empty-cart-button"
              onClick={() => {
                setCart([]);
                setIsEmpty(true);
              }}
            >
              <div className="text">
                <p>{t("clear-cart")}</p>
              </div>
              <div className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.833 5.83337C15.612 5.83337 15.4 5.92117 15.2438 6.07745C15.0875 6.23373 14.9997 6.44569 14.9997 6.66671V15.9925C14.9758 16.4139 14.7863 16.8088 14.4726 17.0912C14.1589 17.3736 13.7463 17.5205 13.3247 17.5H6.67467C6.25309 17.5205 5.84049 17.3736 5.52676 17.0912C5.21303 16.8088 5.02358 16.4139 4.99967 15.9925V6.66671C4.99967 6.44569 4.91188 6.23373 4.7556 6.07745C4.59932 5.92117 4.38735 5.83337 4.16634 5.83337C3.94533 5.83337 3.73337 5.92117 3.57709 6.07745C3.42081 6.23373 3.33301 6.44569 3.33301 6.66671V15.9925C3.35679 16.8561 3.72183 17.675 4.34816 18.2699C4.97449 18.8648 5.81107 19.1873 6.67467 19.1667H13.3247C14.1883 19.1873 15.0249 18.8648 15.6512 18.2699C16.2775 17.675 16.6426 16.8561 16.6663 15.9925V6.66671C16.6663 6.44569 16.5785 6.23373 16.4223 6.07745C16.266 5.92117 16.054 5.83337 15.833 5.83337Z"
                    fill="#FEAC7A"
                  />
                  <path
                    d="M16.6667 3.33337H13.3333V1.66671C13.3333 1.44569 13.2455 1.23373 13.0893 1.07745C12.933 0.921171 12.721 0.833374 12.5 0.833374H7.5C7.27899 0.833374 7.06702 0.921171 6.91074 1.07745C6.75446 1.23373 6.66667 1.44569 6.66667 1.66671V3.33337H3.33333C3.11232 3.33337 2.90036 3.42117 2.74408 3.57745C2.5878 3.73373 2.5 3.94569 2.5 4.16671C2.5 4.38772 2.5878 4.59968 2.74408 4.75596C2.90036 4.91224 3.11232 5.00004 3.33333 5.00004H16.6667C16.8877 5.00004 17.0996 4.91224 17.2559 4.75596C17.4122 4.59968 17.5 4.38772 17.5 4.16671C17.5 3.94569 17.4122 3.73373 17.2559 3.57745C17.0996 3.42117 16.8877 3.33337 16.6667 3.33337ZM8.33333 3.33337V2.50004H11.6667V3.33337H8.33333Z"
                    fill="#FEAC7A"
                  />
                  <path
                    d="M9.16667 14.1667V8.33333C9.16667 8.11232 9.07887 7.90036 8.92259 7.74408C8.76631 7.5878 8.55435 7.5 8.33333 7.5C8.11232 7.5 7.90036 7.5878 7.74408 7.74408C7.5878 7.90036 7.5 8.11232 7.5 8.33333V14.1667C7.5 14.3877 7.5878 14.5996 7.74408 14.7559C7.90036 14.9122 8.11232 15 8.33333 15C8.55435 15 8.76631 14.9122 8.92259 14.7559C9.07887 14.5996 9.16667 14.3877 9.16667 14.1667Z"
                    fill="#FEAC7A"
                  />
                  <path
                    d="M12.4997 14.1667V8.33333C12.4997 8.11232 12.4119 7.90036 12.2556 7.74408C12.0993 7.5878 11.8874 7.5 11.6663 7.5C11.4453 7.5 11.2334 7.5878 11.0771 7.74408C10.9208 7.90036 10.833 8.11232 10.833 8.33333V14.1667C10.833 14.3877 10.9208 14.5996 11.0771 14.7559C11.2334 14.9122 11.4453 15 11.6663 15C11.8874 15 12.0993 14.9122 12.2556 14.7559C12.4119 14.5996 12.4997 14.3877 12.4997 14.1667Z"
                    fill="#FEAC7A"
                  />
                </svg>
              </div>
            </div>
          )}
        </div>
      )}

      {orderSteps === 1 && isEmpty ? (
        <div className="empty-cart">
          <div className="message">
            <div className="icon">
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.8338 16.9688H7.78171L7.5838 15.323L20.1984 14.3334C21.0525 14.2605 21.7505 13.6042 21.865 12.7501L22.0109 11.6042C22.063 11.1771 21.7609 10.7813 21.3338 10.7292C20.8963 10.6771 20.5109 10.9792 20.4588 11.4063L20.313 12.5521C20.3025 12.6771 20.1984 12.7709 20.0734 12.7709L7.3963 13.7709L6.49005 6.04172H11.49C11.9171 6.04172 12.2713 5.68756 12.2713 5.26047C12.2713 4.83339 11.9171 4.47922 11.49 4.47922H6.30255L6.18796 3.47922C6.05255 2.30214 5.18796 1.32297 4.04213 1.03131L1.2713 0.333389C0.85463 0.229222 0.427546 0.479223 0.323379 0.906306C0.219213 1.32297 0.469213 1.75006 0.896296 1.85422L3.66713 2.55214C4.18796 2.67714 4.5838 3.12506 4.6463 3.66672L6.24005 17.2084C5.2088 17.6355 4.46921 18.6667 4.46921 19.8542C4.46921 21.4376 5.75046 22.7188 7.3338 22.7188C8.91713 22.7188 10.1984 21.4376 10.1984 19.8542C10.1984 19.3855 10.0734 18.948 9.87546 18.5521H17.3025C17.1046 18.948 16.9796 19.3855 16.9796 19.8542C16.9796 21.4376 18.2609 22.7188 19.8442 22.7188C21.4275 22.7188 22.7088 21.4376 22.7088 19.8542C22.7088 18.2709 21.4275 16.9896 19.8442 16.9896L19.8338 16.9688ZM8.63588 19.8334C8.63588 20.5521 8.05255 21.1355 7.3338 21.1355C6.61505 21.1355 6.03171 20.5521 6.03171 19.8334C6.03171 19.1146 6.61505 18.5313 7.3338 18.5313C8.05255 18.5313 8.63588 19.1146 8.63588 19.8334ZM19.8338 21.1355C19.115 21.1355 18.5317 20.5521 18.5317 19.8334C18.5317 19.1146 19.115 18.5313 19.8338 18.5313C20.5525 18.5313 21.1359 19.1146 21.1359 19.8334C21.1359 20.5521 20.5525 21.1355 19.8338 21.1355ZM15.6359 7.30214L17.688 5.25006L15.6359 3.19797C15.3338 2.89589 15.3338 2.39589 15.6359 2.09381C15.938 1.79172 16.438 1.79172 16.74 2.09381L18.7921 4.14589L20.8442 2.09381C21.1463 1.79172 21.6463 1.79172 21.9484 2.09381C22.2505 2.39589 22.2505 2.89589 21.9484 3.19797L19.8963 5.25006L21.9484 7.30214C22.2505 7.60422 22.2505 8.10422 21.9484 8.40631C21.7921 8.56256 21.5942 8.63547 21.3963 8.63547C21.1984 8.63547 21.0005 8.56256 20.8442 8.40631L18.7921 6.35422L16.74 8.40631C16.5838 8.56256 16.3859 8.63547 16.188 8.63547C15.99 8.63547 15.7921 8.56256 15.6359 8.40631C15.3338 8.10422 15.3338 7.60422 15.6359 7.30214Z"
                  fill="#FEAC7A"
                />
              </svg>
            </div>
            <div className="text">
              <p>{t("empty-cart")}</p>
            </div>
          </div>
        </div>
      ) : (
        orderSteps === 1 && (
          <div className="cart-products">
            {window.screen.width > 767 && cart.length > 0 && (
              <div className="cart-table-info">
                <div className="left">
                  <div className="product">
                    <p>{t("product")}</p>
                  </div>
                </div>
                <div className="right">
                  <div className="single-price">
                    <p>{t("price")}</p>
                  </div>
                  <div className="amount">
                    <p>{t("amount")}</p>
                  </div>
                  <div className="final-price">
                    <p>{t("final-price")}</p>
                  </div>
                </div>
              </div>
            )}
            {nonDuplicateCart.length > 0 && (
              <>
                <div className="products">
                  {nonDuplicateCart?.map((item) => {
                    return (
                      <Product
                        key={`${item.id}_${item.chosenWeight ?? ""}`}
                        product={item}
                        finalPrice={finalPrice}
                        setFinalPrice={setFinalPrice}
                        setCart={setCart}
                        cart={cart}
                        user={user}
                        showMessage={showMessage}
                        setShowMessage={setShowMessage}
                        isCombo={item.isCombo}
                        weight={item?.weight}
                      ></Product>
                    );
                  })}
                </div>
                <div className="final-price">
                  <p>{t("total-value")}</p>
                  <span>
                    .........................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................................
                  </span>
                  <p className="price">
                    {Number(finalPrice)?.toFixed(2)} {t("€/")}
                    {finalPriceBGN !== null
                      ? finalPriceBGN + t("lv")
                      : "Converting.../"}
                  </p>
                </div>
              </>
            )}
          </div>
        )
      )}
      {orderSteps === 1 && (
        <div className="bottom">
          <div className="row">
            {!isEmpty && (
              <div className="left">
                <div className="label">
                  <p>{t("type-of-delivery")}:</p>
                </div>
                <div className="checkbox-wrap">
                  <input
                    id="vzimane"
                    type="checkbox"
                    onChange={() => {
                      setDeliveryOrTake(1);
                    }}
                    checked={deliverOrTake !== 0 && deliverOrTake !== 2}
                  />
                  <label for="vzimane">{t("pickup")}</label>
                </div>
                <div className="checkbox-wrap">
                  <input
                    id="dostavka"
                    type="checkbox"
                    onChange={() => {
                      setDeliveryOrTake(2);
                    }}
                    checked={deliverOrTake !== 0 && deliverOrTake !== 1}
                  />
                  <label for="dostavka">{t("delivery")}</label>
                </div>
              </div>
            )}
            <div className="buttons">
              <div className="back-to-menu-button">
                <button onClick={() => navigate("/menu/category/10")}>
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23"
                      height="8"
                      viewBox="0 0 23 8"
                      fill="none"
                    >
                      <path
                        d="M5.83337 4H22.1667"
                        stroke="#343434"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M0.357288 3.78563L4.62174 1.22696C5.15496 0.907026 5.83333 1.29112 5.83333 1.91295V6.08705C5.83333 6.70888 5.15496 7.09297 4.62174 6.77304L0.357289 4.21437C0.195454 4.11727 0.195454 3.88273 0.357288 3.78563Z"
                        fill="#343434"
                      />
                    </svg>
                  </div>
                  <div className="text">{t("menu")}</div>
                </button>
              </div>
              <div
                className={
                  isEmpty || isDisabled || disabledCategories?.length > 0
                    ? "continue-button disabled"
                    : "continue-button"
                }
              >
                <button
                  disabled={
                    isEmpty || isDisabled || disabledCategories?.length > 0
                  }
                  onClick={() => {
                    if (typeof window.gtag === "function") {
                      window.gtag("event", "begin_checkout", {
                        currency: "EUR",
                        value: finalPrice,
                        items: cart,
                      });
                    } else {
                      console.error("gtag is not defined!");
                    }
                    !user && handleGuest();
                    setOrderSteps(2);
                  }}
                >
                  {t("continue")}
                </button>
              </div>
            </div>
          </div>
          {isDisabled && (
            <div className="row">
              <p className="order-min">{t("min-order-price")}</p>
            </div>
          )}
          {disabledCategories.length > 0 && (
            <div className="row">
              <p className="order-min">
                Продуктите от категории {disabledCategories.join(", ")} са
                недостъпни за поръчка към момента.
              </p>
            </div>
          )}
        </div>
      )}
      {orderSteps === 2 && (
        <div className="order-wrapper">
          <div className="column">
            <div className="section">
              <div className="title">
                <p>{t("delivery-details")}</p>
              </div>
              <div className="content">
                <div className={emailError ? "input error" : "input"}>
                  <input
                    type="email"
                    className="email"
                    placeholder={`${t("email")}*`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div
                  className={phoneError ? "input error phone" : "input phone"}
                >
                  <PhoneInput
                    defaultCountry="BG"
                    country="BG"
                    value={phone}
                    onChange={setPhone}
                    placeholder={`${t("number")}*`}
                  ></PhoneInput>
                </div>
                {deliverOrTake === 2 && (
                  <>
                    <div className="input">
                      <input
                        type="text"
                        className="city"
                        disabled
                        value={"град София"}
                      />
                    </div>
                    <div
                      className={`${
                        neighbourhoodError ? "input error" : "input"
                      }`}
                    >
                      <div
                        ref={neighbourhoodsRef}
                        className={
                          openNeighbourhoodDropdown
                            ? "select active neighbourhoods"
                            : "select"
                        }
                        onClick={() => {
                          setOpenNeighbourhoodDropdown(
                            !openNeighbourhoodDropdown,
                          );
                        }}
                      >
                        <p>
                          {neighbourhoods?.find(function (element) {
                            return element.name === selectedNeighbourhood;
                          })?.name || `Квартал*`}
                        </p>
                        <div className="arrow-down"></div>
                      </div>
                      {openNeighbourhoodDropdown && (
                        <div className="select-dropdown neighbourhoods">
                          {neighbourhoods?.map((address) => {
                            return (
                              <div
                                className={
                                  deliveryError
                                    ? "checkbox-wrap error"
                                    : "checkbox-wrap"
                                }
                              >
                                <input
                                  name={address.name}
                                  type="checkbox"
                                  onChange={() => {
                                    setSelectedNeighbourhood(address.name);
                                    setOpenNeighbourhoodDropdown(false);
                                  }}
                                  checked={
                                    selectedNeighbourhood === address.name
                                  }
                                />
                                <label for={address.name}>
                                  {String(address.name).toLowerCase()}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    <div
                      className={
                        streetError ? "input street error" : "input street"
                      }
                    >
                      <>
                        <div
                          ref={addressRef}
                          className={
                            openAddressDropdown ? "select active" : "select"
                          }
                          onClick={() => {
                            setOpenAddressDropdown(!openAddressDropdown);
                          }}
                        >
                          <input
                            type="text"
                            className="street"
                            placeholder={`${t("street")}*`}
                            value={street === "new" ? "" : street}
                            onChange={(e) => setStreet(e.target.value)}
                          />
                        </div>
                        {addresses.length > 0 && openAddressDropdown && (
                          <div className="select-dropdown">
                            {addresses.length > 0 &&
                              addresses?.map((address) => {
                                return (
                                  <div
                                    className={
                                      deliveryError
                                        ? "checkbox-wrap error"
                                        : "checkbox-wrap"
                                    }
                                  >
                                    <input
                                      name={address.address}
                                      type="checkbox"
                                      onChange={() => {
                                        setStreet(
                                          street === address.address
                                            ? ""
                                            : address.address,
                                        );
                                      }}
                                      checked={street === address.address}
                                    />
                                    <label for={address.address}>
                                      {address.address}
                                    </label>
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </>

                      <div className="delivery-door">
                        <div className="icon">
                          <img
                            src="https://alexfish-static.s3.eu-north-1.amazonaws.com/info.svg"
                            alt="Info"
                          />
                        </div>
                        {t("delivery-door")}
                      </div>
                    </div>

                    <div
                      className={!fullAddress ? "map-wrap" : "map-wrap large"}
                    >
                      <div className="map">
                        {!fullAddress ? (
                          <div
                            className={
                              !wrongAddress ? "message" : "message error"
                            }
                          >
                            <p>{t("map-shows")}</p>
                          </div>
                        ) : (
                          <iframe
                            title="maps"
                            width="100%"
                            height={"100%"}
                            style={{ borderRadius: "9px", border: "none" }}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAiV1MSCdZ3CQmTsQ4Wi_CjTDwItLzhrbU&q=${fullAddress}`}
                          ></iframe>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="section">
              <div className="title">
                <p>
                  {deliverOrTake === 1
                    ? `${t("time-of-delivery")}`
                    : `${t("time-of-delivery")}`}
                </p>
              </div>
              <div className="content">
                <div
                  className={
                    deliveryError ? "checkbox-wrap error" : "checkbox-wrap"
                  }
                >
                  <input
                    type="checkbox"
                    id="delivery-now"
                    onChange={() => {
                      setDeliveryOption(1);
                    }}
                    checked={deliveryOption !== 2 && deliveryOption !== 0}
                  />
                  <label htmlFor="delivery-now">
                    {deliverOrTake === 1 ? `${t("asap")}` : `${t("asap")}`}
                  </label>
                </div>
                {/* <div
                  className={
                    deliveryError ? "checkbox-wrap error" : "checkbox-wrap"
                  }
                >
                  <input
                    type="checkbox"
                    id="delivery-later"
                    onChange={() => {
                      setDeliveryOption(2);
                    }}
                    checked={deliveryOption !== 1 && deliveryOption !== 0}
                  />
                  <label htmlFor="delivery-later">{t("specific")}</label>
                </div>
                {deliveryOption === 2 && (
                  <div className="delivery-later-content">
                    <div className="select delivery">
                      <input
                        type="date"
                        min={new Date().toISOString().split("T")[0]}
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                      />
                    </div>
                    <div className="select delivery">
                      <select
                        value={hours}
                        onChange={(e) => setHours(e.target.value)}
                      >
                        <option selected disabled>
                          Час
                        </option>
                        {renderHours()}
                      </select>
                    </div>
                    <div className="select delivery">
                      <select
                        value={minutes}
                        onChange={(e) => setMinutes(e.target.value)}
                      >
                        <option selected disabled>
                          Минути
                        </option>
                        <option value={0} key={0}>
                          00
                        </option>
                        {renderMinutes()}
                      </select>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
            {deliverOrTake === 1 && (
              <div className="section">
                <div className="title">
                  <p>{t("payment-method")}</p>
                </div>
                <div className="content">
                  <div
                    className={
                      paymentError ? "checkbox-wrap error" : "checkbox-wrap"
                    }
                  >
                    <input
                      type="checkbox"
                      id="cash-on-delivery"
                      onChange={() => {
                        setPaymentMethod(1);
                      }}
                      checked={paymentMethod !== 0 && paymentMethod !== 2}
                    />
                    <label htmlFor="cash-on-delivery">
                      {t("cash-on-delivery")}
                    </label>
                  </div>
                  <div
                    className={
                      paymentError ? "checkbox-wrap error" : "checkbox-wrap"
                    }
                  >
                    <input
                      type="checkbox"
                      id="card-on-delivery"
                      onChange={() => {
                        setPaymentMethod(2);
                      }}
                      checked={paymentMethod !== 0 && paymentMethod !== 1}
                    />
                    <label htmlFor="card-on-delivery">
                      {t("card-on-delivery")}
                    </label>
                  </div>
                  <div className="input w-button">
                    <input
                      type="text"
                      className="promo-code"
                      placeholder={`${t("promo-code")}`}
                      value={usedPromocode}
                      onChange={(e) => setUsedPromocode(e.target.value)}
                    />
                    <button
                      onClick={handlePromocode}
                      className={
                        usedPromocode === ""
                          ? "apply-promocode disabled"
                          : "apply-promocode"
                      }
                      disabled={usedPromocode === ""}
                    >
                      {t("apply")}
                    </button>
                  </div>
                  {promoAlreadyApplied ? (
                    <p className="promo-applied">Промокодът е приложен.</p>
                  ) : (
                    <></>
                  )}
                  {promoError ? (
                    <p className="promo-error">{promoError}</p>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            )}
            {deviceType === "mobile" && stepError && (
              <p className="step-error">{t("fill-required-fields")}</p>
            )}
            {deviceType === "mobile" && (
              <div className="section buttons">
                <button
                  className="button border"
                  onClick={() => setOrderSteps(1)}
                >
                  {orderSteps === 2 ? `${t("cart")}` : "Назад"}
                </button>
                <button className="button fill" onClick={handleDeliveryStep}>
                  {t("continue")}
                </button>
              </div>
            )}
          </div>
          {deviceType === "desktop" && (
            <div className="column">
              {deliverOrTake === 2 && (
                <div className="section">
                  <div className="title">
                    <p>{t("payment-method")}</p>
                  </div>
                  <div className="content">
                    <div
                      className={
                        paymentError ? "checkbox-wrap error" : "checkbox-wrap"
                      }
                    >
                      <input
                        type="checkbox"
                        id="cash-on-delivery"
                        onChange={() => {
                          setPaymentMethod(1);
                        }}
                        checked={paymentMethod !== 0 && paymentMethod !== 2}
                      />
                      <label htmlFor="cash-on-delivery">
                        {t("cash-on-delivery")}
                      </label>
                    </div>
                    <div
                      className={
                        paymentError ? "checkbox-wrap error" : "checkbox-wrap"
                      }
                    >
                      <input
                        type="checkbox"
                        id="card-on-delivery"
                        onChange={() => {
                          setPaymentMethod(2);
                        }}
                        checked={paymentMethod !== 0 && paymentMethod !== 1}
                      />
                      <label htmlFor="card-on-delivery">
                        {t("card-on-delivery")}
                      </label>
                    </div>
                    <div className="input w-button">
                      <input
                        type="text"
                        className="promo-code"
                        placeholder={`${t("promo-code")}`}
                        value={usedPromocode}
                        onChange={(e) => setUsedPromocode(e.target.value)}
                      />
                      <button
                        onClick={handlePromocode}
                        className={
                          usedPromocode === ""
                            ? "apply-promocode disabled"
                            : "apply-promocode"
                        }
                        disabled={usedPromocode === ""}
                      >
                        {t("apply")}
                      </button>
                    </div>
                    {promoAlreadyApplied ? (
                      <p className="promo-applied">Промокодът е приложен.</p>
                    ) : (
                      <></>
                    )}
                    {promoError ? (
                      <p className="promo-error">{promoError}</p>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
              <div className="section">
                <div className="title">
                  <p>{t("order-summary")}</p>
                </div>
                <div className="content">
                  <div className="summary">
                    <div className="row">
                      <p>{t("order-value")}</p>
                      <p className="price">
                        {Number(finalPrice)?.toFixed(2)} {t("€/")}
                        {finalPriceBGN !== null
                          ? finalPriceBGN + t("lv")
                          : "Converting..."}
                      </p>
                    </div>
                    {deliveryFee !== 0 && (
                      <div className="row">
                        <p>{t("delivery-tax")}</p>
                        <p className="price">
                          {deliveryFee} {t("€/")}
                          {deliveryFeeBGN !== null
                            ? deliveryFeeBGN + t("lv")
                            : "Converting..."}
                        </p>
                      </div>
                    )}
                    {discount !== 0 && (
                      <div className="row">
                        <p>
                          Отстъпка{" "}
                          {validPromo?.percent !== null &&
                            `(${validPromo.percent}%)`}
                        </p>
                        <p className="price">
                          - {discount} {t("€/")}
                          {discountBGN !== null
                            ? discountBGN + t("lv")
                            : "Converting..."}
                        </p>
                      </div>
                    )}
                    <div className="row bold">
                      <p>{t("total")}</p>
                      <p className="price">
                        {(finalPrice + Number(deliveryFee)).toFixed(2)}{" "}
                        {t("€/")}
                        {finalWithDeliveryBGN !== null
                          ? finalWithDeliveryBGN + t("lv")
                          : "Converting..."}
                      </p>
                    </div>
                  </div>
                  <div className="input">
                    <input
                      type="text"
                      className="comment"
                      placeholder={`${t("comment")}`}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </div>
                  <div
                    className={
                      deliverOrTake === 1 ? "agreements margin" : "agreements"
                    }
                  >
                    <div
                      className={
                        policyError ? "checkbox-wrap error" : "checkbox-wrap"
                      }
                    >
                      <input
                        type="checkbox"
                        id="policy"
                        onClick={() => setPolicyConfirm(!policyConfirm)}
                        checked={policyConfirm}
                      ></input>
                      <label>
                        {t("agree-policy")}{" "}
                        <a href="#">{t("privacy-policy")}</a> *
                      </label>
                    </div>
                    <div
                      className={
                        termsError ? "checkbox-wrap error" : "checkbox-wrap"
                      }
                    >
                      <input
                        type="checkbox"
                        id="terms"
                        onClick={() => setTermsConfirm(!termsConfirm)}
                        checked={termsConfirm}
                      ></input>
                      <label>
                        {t("agree-terms")}{" "}
                        <a href="#">{t("terms-and-conditions")}</a> *
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section buttons">
                <button
                  className="button border"
                  onClick={() => {
                    setOrderSteps(1);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="8"
                    viewBox="0 0 23 8"
                    fill="none"
                  >
                    <path
                      d="M5.83337 4H22.1667"
                      stroke="#343434"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M0.357288 3.78563L4.62174 1.22696C5.15496 0.907026 5.83333 1.29112 5.83333 1.91295V6.08705C5.83333 6.70888 5.15496 7.09297 4.62174 6.77304L0.357289 4.21437C0.195454 4.11727 0.195454 3.88273 0.357288 3.78563Z"
                      fill="#343434"
                    />
                  </svg>
                  <p>{orderSteps === 2 ? `${t("cart")}` : `${t("back")}`}</p>
                </button>
                <button
                  className={
                    isDisabled || isSubmitting
                      ? "button fill disabled"
                      : "button fill"
                  }
                  disabled={isDisabled || isSubmitting}
                  onClick={handleOrder}
                >
                  {isSubmitting ? t("sending-order") : t("send-order")}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {orderSteps === 3 && (
        <div className="order-wrapper">
          <div className="column">
            {deliverOrTake === 2 && (
              <div className="section">
                <div className="title">
                  <p>{t("payment-method")}</p>
                </div>
                <div className="content">
                  <div
                    className={
                      paymentError ? "checkbox-wrap error" : "checkbox-wrap"
                    }
                  >
                    <input
                      type="checkbox"
                      id="cash-on-delivery"
                      onChange={() => {
                        setPaymentMethod(1);
                      }}
                      checked={paymentMethod !== 0 && paymentMethod !== 2}
                    />
                    <label htmlFor="cash-on-delivery">
                      {t("cash-on-delivery")}
                    </label>
                  </div>
                  <div
                    className={
                      paymentError ? "checkbox-wrap error" : "checkbox-wrap"
                    }
                  >
                    <input
                      type="checkbox"
                      id="card-on-delivery"
                      onChange={() => {
                        setPaymentMethod(2);
                      }}
                      checked={paymentMethod !== 0 && paymentMethod !== 1}
                    />
                    <label htmlFor="card-on-delivery">
                      {t("card-on-delivery")}
                    </label>
                  </div>
                  <div className="input w-button">
                    <input
                      type="text"
                      className="promo-code"
                      placeholder={`${t("promo-code")}`}
                      value={usedPromocode}
                      onChange={(e) => setUsedPromocode(e.target.value)}
                    />
                    <button
                      onClick={handlePromocode}
                      className={
                        usedPromocode === ""
                          ? "apply-promocode disabled"
                          : "apply-promocode"
                      }
                      disabled={usedPromocode === ""}
                    >
                      {t("apply")}
                    </button>
                  </div>
                  {promoAlreadyApplied ? (
                    <p className="promo-applied">Промокодът е приложен.</p>
                  ) : (
                    <></>
                  )}
                  {promoError ? (
                    <p className="promo-error">{promoError}</p>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            )}
            <div className="section">
              <div className="title">
                <p>{t("order-summary")}</p>
              </div>
              <div className="content">
                <div className="summary">
                  <div className="row">
                    <p>{t("order-value")}</p>
                    <p className="price">
                      {Number(finalPrice)?.toFixed(2)} {t("€")}/
                      {finalPriceBGN !== null
                        ? finalPriceBGN + t("lv")
                        : "Converting..."}
                    </p>
                  </div>
                  {deliveryFee !== 0 && (
                    <div className="row">
                      <p>{t("delivery-tax")}</p>
                      <p className="price">
                        {deliveryFee} {t("€/")}
                        {deliveryFeeBGN !== null
                          ? deliveryFeeBGN + t("lv")
                          : "Converting.../"}
                      </p>
                    </div>
                  )}
                  {discount !== 0 && (
                    <div className="row">
                      <p>
                        Отстъпка{" "}
                        {validPromo?.percent !== null &&
                          `(${validPromo.percent}%)`}
                      </p>
                      <p className="price">
                        -{discount}
                        {"€/"}
                        {discountBGN !== null
                          ? Number(discountBGN)?.toFixed(2) + t("lv")
                          : "Converting.../"}
                      </p>
                    </div>
                  )}
                  <div className="row bold">
                    <p>{t("total")}</p>
                    <p className="price">
                      {Number(finalPrice + Number(deliveryFee))?.toFixed(2)}{" "}
                      {"€/"}
                      {finalWithDeliveryBGN !== null
                        ? Number(finalWithDeliveryBGN)?.toFixed(2) + t("lv")
                        : "Converting..."}
                    </p>
                  </div>
                </div>
                <div className="input">
                  <input
                    type="text"
                    className="comment"
                    placeholder="Коментар към поръчката"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>
                <div
                  className={
                    deliverOrTake === 1 ? "agreements margin" : "agreements"
                  }
                >
                  <div
                    className={
                      policyError ? "checkbox-wrap error" : "checkbox-wrap"
                    }
                  >
                    <input
                      type="checkbox"
                      id="policy"
                      onClick={() => setPolicyConfirm(!policyConfirm)}
                    ></input>
                    <label>
                      {t("agree-policy")} <a href="#">{t("privacy-policy")}</a>{" "}
                      *
                    </label>
                  </div>
                  <div
                    className={
                      termsError ? "checkbox-wrap error" : "checkbox-wrap"
                    }
                  >
                    <input
                      type="checkbox"
                      id="terms"
                      onClick={() => setTermsConfirm(!termsConfirm)}
                    ></input>
                    <label>
                      {t("agree-terms")}{" "}
                      <a href="#">{t("terms-and-conditions")}</a> *
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="section buttons">
              <button
                className="button border"
                onClick={() => {
                  {
                    orderSteps === 2 ? setOrderSteps(1) : setOrderSteps(2);
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="8"
                  viewBox="0 0 23 8"
                  fill="none"
                >
                  <path
                    d="M5.83337 4H22.1667"
                    stroke="#343434"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M0.357288 3.78563L4.62174 1.22696C5.15496 0.907026 5.83333 1.29112 5.83333 1.91295V6.08705C5.83333 6.70888 5.15496 7.09297 4.62174 6.77304L0.357289 4.21437C0.195454 4.11727 0.195454 3.88273 0.357288 3.78563Z"
                    fill="#343434"
                  />
                </svg>
                <p>{orderSteps === 2 ? `${t("cart")}` : `${t("back")}`}</p>
              </button>
              <button
                className={
                  isDisabled || isSubmitting
                    ? "button fill disabled"
                    : "button fill"
                }
                disabled={isDisabled || isSubmitting}
                onClick={handleOrder}
              >
                {isSubmitting ? t("sending-order") : t("send-order")}
              </button>
            </div>
          </div>
        </div>
      )}
      {orderError && (
        <div className="row">
          <p className="order-min">{orderError}</p>
        </div>
      )}
      {confirmShow && (
        <div className="confirmation">
          <div className="popup">
            <div className="image"></div>
            <div className="text">
              <div className="confirm-title">{t("order-confirmed")}</div>
              <div className="confirm-subtitle">
                {t("confirmation-message")}
              </div>
            </div>
            <div className="buttons">
              <button
                className="fill"
                onClick={() => {
                  setOpenConfirmation(false);
                  setConfirmShow(false);
                  navigate("/");
                  setCart([]);
                }}
              >
                {t("okay")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
